export default __webpack_public_path__ + "static/media/2.7de1a4f5.jpg";